<div class="page">
    <div class="title">
        <div class="titleValue">{{ "general.warrantyService" | transloco }}</div>
        <div class="line"></div>
    </div>
    <div class="layoutRegister">
        <div class="register">
            <div class="titleForm">
                {{ step === 1 ? ("register.title1" | transloco) : step === 2 ? ("register.title2" | transloco) : "" }}
            </div>
            <form *ngIf="step === 1" [formGroup]="formDatos" class="registerForm">
                <div class="inputRegisterGroup">
                    <mat-label class="labelRegister">{{ "general.name" | transloco }} (*)</mat-label>
                    <input class="inputRegister" matInput name="nombre" type="text" formControlName="nombre"
                        [placeholder]="'general.namePlaceholder' | transloco" maxlength="200" />
                </div>

                <div class="inputRegisterGroup" style="margin-top: 22px;">
                    <mat-label class="labelRegister">{{ "general.surname" | transloco }}</mat-label>
                    <input class="inputRegister" matInput name="apellidos" type="text" formControlName="apellidos"
                    [placeholder]="'general.surnamePlaceholder' | transloco" maxlength="200" />
                </div>

                <div class="inputRegisterGroup" style="margin-top: 22px;">
                    <mat-label class="labelRegister">{{ "general.email" | transloco }} (*)</mat-label>
                    <input class="inputRegister" [class.inputRegisterRed]="!validEmail && validEmail !== undefined"
                        matInput name="email" type="email" formControlName="email" [placeholder]="'general.emailPlaceholder' | transloco"
                        maxlength="200" (blur)="comprobarEmail()" />
                </div>

                <span *ngIf="errorEmail">{{ errorEmail }}</span>

                <div class="inputRegisterGroup" style="margin-top: 22px;">
                    <mat-label class="labelRegister">{{ "register.password" | transloco }} (*)</mat-label>
                    <input class="inputRegister" [class.inputRegisterRed]="!validPass && validPass !== undefined"
                        matInput name="password" type="password" formControlName="password"
                        [placeholder]="'register.passwordPlaceholder' | transloco" maxlength="200" />
                </div>

                <div class="inputRegisterGroup" style="margin-top: 22px;">
                    <mat-label class="labelRegister">{{ "register.confirmPassword" | transloco }} (*)</mat-label>
                    <input class="inputRegister" [class.inputRegisterRed]="!validPass && validPass !== undefined"
                        matInput name="confirmPass" type="password" formControlName="confirmPass"
                        [placeholder]="'register.confirmPasswordPlaceholder' | transloco" maxlength="200" (blur)="comprobarPass()" />
                </div>

                <div class="inputCheckboxGroup" style="margin-top: 22px;">
                    <input class="inputCheckbox" name="politica" type="checkbox" formControlName="politica"
                        maxlength="200" />
                    <mat-label class="labelPolitica" [innerHTML]="'general.termsAndPolicyCheck' | transloco: {termsLink: '/terminos-condiciones-app', policyLink: '/politica-privacidad'}"></mat-label>
                </div>

                <div class="inputCheckboxGroup" style="margin-top: 22px;">
                    <input class="inputCheckbox" name="consentimiento" type="checkbox" formControlName="consentimiento"
                        maxlength="200" />
                    <mat-label class="labelPolitica">{{ "register.marketingCheck" | transloco }}</mat-label>
                </div>
            </form>

            <form *ngIf="step === 2" [formGroup]="formDireccion" class="registerForm">
                <div class="inputRegisterGroup" style="margin-top: 22px;">
                    <mat-label class="labelRegister">{{ "register.address" | transloco }}</mat-label>
                    <input class="inputRegister" matInput name="direccion" formControlName="direccion"
                        [placeholder]="'register.addressPlaceholder' | transloco" maxlength="200" />
                </div>

                <div class="inputRegisterGroup" style="margin-top: 22px;">
                    <mat-label class="labelRegister">{{ "general.postalCode" | transloco }} (*)</mat-label>
                    <input class="inputRegister" matInput name="codigoPostal" formControlName="codigoPostal"
                        [placeholder]="'general.postalCodePlaceholder' | transloco" maxlength="200" />
                </div>

                <div class="inputRegisterGroup" style="margin-top: 22px;">
                    <mat-label class="labelRegister">{{ "general.phone" | transloco }}</mat-label>
                    <input class="inputRegister" matInput name="phone" type="tel" formControlName="phone"
                        [placeholder]="'general.phonePlaceholder' | transloco" maxlength="200" />
                </div>
            </form>

            <div *ngIf="step === 3">
                <div style="font-weight: 600; font-size: 20px;">
                    {{ "register.successTitle" | transloco }}
                </div>
                <div style="margin: 20px 0;">
                    {{ "register.codeMessage" | transloco }}
                </div>
                <form [formGroup]="formCodigoActivacion" class="registerForm">
                    <div class="inputRegisterGroup">
                        <mat-label class="labelRegister">{{ "register.activationCode" | transloco }} (*)</mat-label>
                        <input class="inputRegister" matInput name="codigo" type="text" formControlName="codigo"
                            [placeholder]="'register.activationCodePlaceholder' | transloco" maxlength="5" />
                    </div>
                    <div *ngIf="errorCodigo" class="error-message" style="color: red; margin-top: 10px;">
                        {{ errorCodigo }}
                    </div>
                </form>
            </div>

            <div *ngIf="step === 4">
                <div style="font-weight: 600; font-size: 20px; color: green;">
                    {{ "register.accountActivated" | transloco }}
                </div>
                <div style="margin: 20px 0;">
                    {{ "register.activationSuccess" | transloco }}
                </div>
            </div>

            <div class="actionButtons">
                <button *ngIf="step === 1 || step === 2" class="buttonVolver" (click)="changeStepBack()">{{ "general.back" | transloco }}</button>
                <button *ngIf="step === 1" class="buttonSiguiente"
                    [disabled]="!(formDatos.valid && validEmail && validPass)" (click)="changeStepNext()">→</button>
                <button *ngIf="step === 2" class="buttonCrear" [disabled]="!formDireccion.valid"
                    (click)="registrar()">{{ "register.createAccount" | transloco }}</button>
                <button *ngIf="step === 3" class="buttonCrear" [disabled]="!formCodigoActivacion.valid"
                    (click)="verificarCodigo()">{{ "register.verifyCode" | transloco }}</button>
                <button *ngIf="step === 3" class="buttonVolver" (click)="reenviarCodigo()">{{ "register.resendCode" | transloco }}</button>
                <button *ngIf="step === 4" class="buttonCrear" (click)="volverALogin()">{{ "register.returnToLogin" | transloco }}</button>
            </div>
        </div>
        <div class="stepMap">
            <div class="verticalLine1"></div>
            <div [class]="step === 1 ? 'stepActive' : 'stepInactive'">1</div>
            <div class="verticalLine2"></div>
            <div [class]="step === 2 ? 'stepActive' : 'stepInactive'">2</div>
            <div class="verticalLine2"></div>
            <div [class]="step === 3 ? 'stepActive' : 'stepInactive'">3</div>
            <div class="verticalLine2"></div>
            <div [class]="step === 4 ? 'stepActive' : 'stepInactive'">4</div>
        </div>
    </div>
</div>